
// router.js（路由配置文件）
import routes from '@/router' //
import { checkDevice } from '@/api'

export function getData () {
  // 从URL参数中获取deviceCode
  const deviceCode = new URLSearchParams(window.location.search).get('deviceCode')
  if (!deviceCode) {
    // 未获取到设备码
    console.log('未获取到设备码')
    if (window.parent !== window) {
      const eventData = {
        type: 'noDevice',
        timestamp: new Date().toISOString()
      }
      window.parent.postMessage(eventData, '*')
    } else {
      location.href = 'https://faq.ruizhihuitech.com'
    }
    return
  }
  checkDevice(deviceCode).then(res => {
    // 检查设备是否存在
    if (!res.data.data) {
      // 设备不存在或未授权
      console.log('设备不存在或未授权')
      if (window.parent !== window) {
        const eventData = {
          type: 'noDevice',
          timestamp: new Date().toISOString()
        }
        window.parent.postMessage(eventData, '*')
      } else {
        location.href = 'https://faq.ruizhihuitech.com'
      }
    }
  })
  document.addEventListener('click', (event) => {
    // 向父页面发送点击通知
    window.parent.postMessage('click', '*')
  })
  routes.afterEach((to, from, next) => {
    console.log('即将从', from.path, '跳转到', to.path)
    const eventData = {
      type: 'routeChange',
      payload: {
        path: to.path
      },
      timestamp: new Date().toISOString()
    }
    window.parent.postMessage(eventData, '*')
  })
}
